import React, { useRef, useState } from 'react';

import cx from 'classnames';
import { prop } from 'ramda';

import { IWithContentWrapper } from 'components/shared/LandingPage/blocks/BlockWrapper/types';
import { useContainerScrollPosition } from 'components/shared/LandingPage/functions';

import { useLandingV2Context } from '../../../../context';
import { useBlockContext } from '../../Block/context';
import AddNewContent from '../AddNewContent';
import ContentWrapper from '../ContentWrapper';
import s from './index.module.css';
import { IAddNewContentWrapperProps, IBlockWrapperProps } from './types';

function BlockWrapper({ children, hiddenTrash }: IBlockWrapperProps) {
  const blockRef = useRef();
  const [isPopupOpened, setIsPopupOpened] = useState(false);
  const { readonly } = useLandingV2Context();
  const { config, outerDisabledAddingBlocks, onAdd } = useBlockContext();
  const { withContentWrapper } = config;

  if (!children) return null;

  const withContentWrapperOptions: IWithContentWrapper =
    typeof withContentWrapper === 'object' ? withContentWrapper : {};
  const blockClasses = cx(s.block, isPopupOpened && prop('higherZIndex', s), 'custom-block');
  const showAddingBlocks = !(config.disabledAddingBlocks ?? outerDisabledAddingBlocks) && !readonly;

  return (
    <div className={blockClasses} ref={blockRef as any} id="blockWrapper">
      <div className={cx(s.childrenWrapper, 'custom-block-children')}>
        {withContentWrapper ? (
          <ContentWrapper hiddenTrash={hiddenTrash} {...withContentWrapperOptions}>
            {children}
          </ContentWrapper>
        ) : (
          children
        )}
      </div>
      {showAddingBlocks && (
        <AddNewContentWrapper
          onAdd={onAdd}
          onOpenPopup={() => setIsPopupOpened(true)}
          onClosePopup={() => setIsPopupOpened(false)}
        />
      )}
    </div>
  );
}

export function AddNewContentWrapper({ onOpenPopup, onClosePopup, onAdd, alwaysShow }: IAddNewContentWrapperProps) {
  const { isScrolling } = useContainerScrollPosition();
  const { isInsideAccordion } = useBlockContext();

  return (
    <AddNewContent
      className={cx(s.plusVisible, alwaysShow && s.alwaysShow, isScrolling && s.plusNotVisible)}
      onOpenPopup={onOpenPopup}
      onClosePopup={onClosePopup}
      onAdd={onAdd}
      isInsideAccordion={isInsideAccordion}
    />
  );
}

export default BlockWrapper;
